import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import Loader from "../../../components/atoms/loader";
import Axios from "../../../AxiosConfig";
import { useStore } from "../../../store";
const ViewLeave = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { layoutStore } = useStore();
    const [loading, setLoading] = useState(false);
    const [leaveInfo, setLeaveInfo] = useState({});
    const [comment, setComment] = useState("");
    const [statechange, setStatechange] = useState('success')
    useEffect(() => {
        setLoading(true);
        const uuid = location.pathname.split("/").pop();
        Axios.post("/working-days/get-leave-info", { uuid }).then((res) => {
            if (res.data.error) {
                setLoading(false);
                navigate("/leaves");
                return;
            }
            setLeaveInfo(res.data.leaveInfo);
            setLoading(false);

        });
    }, [statechange]);
    const changeLeaveStatus = (status) => {
        setLoading(true);
        Axios.post("/working-days/change-leave-status", { uuid: leaveInfo.uuid, comment, status, employee: leaveInfo.user, workingDays: leaveInfo.workingDays }).then((res) => {
            if (res.data.error) {
                layoutStore.showToaster(res.data.error, "error")
                setLoading(false);
                return;
            }
            layoutStore.showToaster(res.data.success, "success")
            setStatechange(res.data.success);
            setLoading(false);
            navigate("/leaves");
        });
    }
    const goBackButton = () => {
        navigate('/leaves')
    }

    return (
        <div>
            {loading && <Loader />}
            <button
                type="button"
                onClick={goBackButton}
                className="mb-6 inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                Back
            </button>
            <h2 className="text-4xl font-bold tracking-tight text-gray-900 border-b pb-4">
                {leaveInfo && leaveInfo.workingDays} Day(s) leave starting from {new Date(leaveInfo.startDate).toLocaleDateString()}
            </h2>
            <div className="mt-4">
                <table className="min-w-full divide-y divide-gray-300">
                    <tbody className="divide-y divide-gray-200">
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Employee Name

                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo.employee}
                                <button
                                    type="button"
                                    onClick={() => navigate(`/employees/${leaveInfo.user}`)}
                                    className="inline-flex ml-2 items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    View Employee Profile
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Remaining Leaves
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo.leaveBalance}
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Department
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo.department}
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Designation
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo.designation}
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Reason
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo.reason}
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Start Date
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {new Date(leaveInfo.startDate).toLocaleDateString()}
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                End Date
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {new Date(leaveInfo.endDate).toLocaleDateString()}
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Missed Working Days Count
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo && leaveInfo.workingDays}
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Missed Working Days
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                <div className="overflow-x-auto w-96">
                                {leaveInfo.leaveDays && leaveInfo.leaveDays.map((day, index) => {
                                    if (index == (leaveInfo.workingDays - 1)){
                                        return (
                                            <span key={index}>
                                                {new Date(day).toLocaleDateString()}
                                            </span>
                                        )
                                    }
                                    return (
                                        <span key={index}>
                                            {new Date(day).toLocaleDateString()}, {' '}
                                        </span>
                                    )
                                })}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                Comment
                            </td>
                            {leaveInfo.status === "Pending" ?
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                <textarea id="admin_comment_on_leave" onChange={(e)=> setComment(e.target.value)} maxLength={"60"} className="block w-full rounded-md border border-gray-300 shadow-sm p-2 focus:border-blue-500 focus:ring-blue-500 sm:text-sm resize-none" placeholder="Optional"/>
                            </td> :
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo.comment || ''}
                            </td>
                            }
                        </tr>
                        <tr>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800 font-semibold">
                                {/* Status */}
                                Action
                            </td>
                            <td className="whitespace-nowrap py-4 px-3 text-sm text-gray-800">
                                {leaveInfo.status === "Approved" && (
                                    <>
                                        <CheckCircleIcon className="h-5 w-5 text-green-700 inline" />
                                        <span className="ml-2 text-green-700">Approved</span>
                                        <button
                                            type="button"
                                            onClick={() => changeLeaveStatus("Denied")}
                                            className="inline-flex ml-3 items-center rounded-md border border-transparent bg-red-100 px-3 py-2 text-sm font-medium leading-4 text-red-700 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                        >
                                            Deny
                                        </button>
                                    </>

                                )}
                                {leaveInfo.status === "Denied" && (
                                    <>
                                        <button
                                            type="button"
                                            onClick={() => changeLeaveStatus("Approved")}
                                            className="inline-flex items-center rounded-md border border-transparent bg-green-100 mr-2 px-3 py-2 text-sm font-medium leading-4 text-green-700 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                        >
                                            Approve
                                        </button>
                                        
                                        <XCircleIcon className="h-5 w-5 text-red-700 inline" />
                                        <span className="ml-2 text-red-700">Denied</span>
                                    </>
                                )}
                                {leaveInfo.status === "Retracted" && (
                                    <>
                                        <XCircleIcon className="h-5 w-5 text-red-700 inline" />
                                        <span className="ml-2 text-red-700">Retracted</span>
                                    </>
                                )}
                                {leaveInfo.status === "Pending" && (
                                    <>
                                        <button
                                            type="button"
                                            onClick={() => changeLeaveStatus("Approved")}
                                            className="inline-flex items-center rounded-md border border-transparent bg-green-100 px-3 py-2 text-sm font-medium leading-4 text-green-700 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                        >
                                            Approve
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => changeLeaveStatus("Denied")}
                                            className="inline-flex ml-3 items-center rounded-md border border-transparent bg-red-100 px-3 py-2 text-sm font-medium leading-4 text-red-700 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                        >
                                            Deny
                                        </button>
                                    </>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default ViewLeave;